import ReactQuill, { UnprivilegedEditor } from 'react-quill';

import 'react-quill/dist/quill.snow.css';
import './rich-text.css';
import React from 'react';
import { FieldError } from 'react-hook-form';
type RichTextProps = {
    onChange: (value: string) => void;
    value: string;
    height: string;
    placeholder: string;
    error: FieldError | null;
    disabled: boolean;
}

const RichText = ({ onChange, value, height, placeholder, error, disabled }: RichTextProps) => {

    const handleChange = (value: string, editor: UnprivilegedEditor) => {
        onChange(editor.getHTML());
    };

    return (
        <div>
            <ReactQuill
                className={`${height}`}
                theme="snow"
                value={value}
                onChange={(value, delta, source, editor) => handleChange(value, editor)}
                placeholder={placeholder}
                readOnly={disabled}
            />
            {error &&
                <div className="text-xs italic text-red-500">
                    {error.message}
                </div>
            }
        </div>
    );
};

export default RichText;
